import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from 'constants/cookies';
import { setAuthCookies, useToast } from '@myhrbox/myhrbox-frontend-core';
import ROUTES from 'constants/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useHandleLogin = () => {
  const navigate = useNavigate();
  const { showErrorToast } = useToast();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const searchObject = Object.fromEntries(searchParams);
  const { redirectUrl } = searchObject;

  return (accessToken?: string, refreshToken?: string) => {
    if (accessToken && refreshToken) {
      const newCookies = [
        { name: ACCESS_TOKEN_NAME, value: accessToken },
        { name: REFRESH_TOKEN_NAME, value: refreshToken },
      ];

      setAuthCookies(newCookies);

      if (redirectUrl) {
        document.location.href = decodeURIComponent(redirectUrl);
      } else {
        navigate(ROUTES.LANGUAGE_SELECT);
      }
    } else {
      showErrorToast(t('errors.common'));
      console.error('нет токенов');
    }
  };
};

export default useHandleLogin;
